import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['branchCodeInput'];

  connect() {
    this.bankData = JSON.parse(this.element.dataset.bankSelectorBankData)
  }

  updateBranchCode(event) {
    const selectedBank = event.target.value
    const branchCode = this.bankData[selectedBank]

    if (this.branchCodeInputTarget) {
      this.branchCodeInputTarget.value = branchCode || ''
    }
  }
}
